import { useEffect } from 'react';
const animatableElementsSelector = '[data-animate-fade]';
const animatableElementsSelectorDelay = '[data-animate-fade-delay]';
/**
 * @deprecated This function doesn't work well with hydration or re-renders.
 *
 * Alternatives:
 *
 * - CSS only approach `starting-fade-in` class for hero animations
 * - `useEnterView for basic animations that just require a class change
 * - Framer for complex animations.
 */
const useAnimateFade = (container, enableAnimations) => {
    useEffect(() => {
        if (!enableAnimations) {
            return;
        }
        const elements = container.current
            ? container.current.querySelectorAll(`${animatableElementsSelector}, ${animatableElementsSelectorDelay}`)
            : [];
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    return;
                }
                const element = entry.target;
                const delay = element.dataset.animateFadeDelay ? parseInt(element.dataset.animateFadeDelay, 10) : 250;
                setTimeout(() => (element.dataset.animateFadeVisible = 'true'), delay);
                observer.unobserve(element);
            });
        }, {
            threshold: 0.1,
            rootMargin: '0px 0px -2% 0px',
        });
        elements.forEach((element) => observer.observe(element));
        return () => observer.disconnect();
    }, [enableAnimations]);
};
export default useAnimateFade;
